import { ICON_WIDTH, ICON_HEIGHT } from "@slhuiicon/icon";

export { ICON_WIDTH, ICON_HEIGHT };
export const PREFIX_NESTING_CLASS = "nesting-";
